import omit from 'lodash/omit';
import classnames from 'classnames';
import React from 'react';
import Avatar from '.';
import Checkbox from '../Checkbox';
import Icon from '../Icon';
import Text from '../Text';
import TextLink from '../TextLink';
import Tooltip from '../Tooltip';
import Constants from '../../../helpers/Constants';
import Tokens from '../styles/Tokens';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = ((theme) => createStyles({
    checkbox: {
        margin: 0
    },
    hideMdUp: {
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    hideSmDown: {
        [theme.breakpoints.down('md')]: {
            display: 'none'
        }
    },
    name: {
        wordBreak: 'normal'
    },
    nameContainer: {
        alignItems: 'center',
        display: 'inline-flex'
    },
    noAvatar: {
        marginLeft: Tokens.spacing30
    },
    primaryText: {
        wordBreak: 'break-all'
    },
    spaceAvatar: {
        marginLeft: '46px'
    },
    spaceAvatarText: {
        [theme.breakpoints.up('md')]: {
            marginRight: Tokens.spacing30
        }
    },
    spaceCheckBox: {
        marginLeft: Tokens.spacing60
    }
}));
const AvatarText = (props) => {
    var _a;
    const { CheckboxProps, IconProps, TextLinkProps, TextLinkTooltipProps, autoHideCheckbox, autoHideSecondaryTextDown, autoHideSecondaryTextUp, avatarInfo, avatarLabel, avatarNoMarginLeft, classes, complement, id, primaryTextProps, secondaryTextProps, showAvatar, showCheckbox, withAvatar } = props;
    return (React.createElement("div", { className: classes.nameContainer },
        CheckboxProps && Boolean(CheckboxProps.id) && CheckboxProps.checked !== undefined && (React.createElement("div", { className: !showCheckbox ? classes.spaceCheckBox : undefined }, showCheckbox && (React.createElement(Checkbox, Object.assign({ classes: {
                focused: classes.checkbox,
                root: autoHideCheckbox ?
                    classnames(classes.checkbox, classes.hideSmDown)
                    : classes.checkbox
            } }, CheckboxProps))))),
        IconProps && (React.createElement(Icon, Object.assign({}, IconProps))),
        withAvatar ? (React.createElement("div", { className: !showAvatar ? classes.spaceAvatar : classes.spaceAvatarText }, showAvatar && Boolean(avatarInfo.hasPicture) && Boolean(avatarInfo.personId) ? (React.createElement(Tooltip, { title: avatarInfo.fullName, "aria-label": avatarInfo.fullName },
            React.createElement(Avatar, { alt: avatarInfo.fullName, id: id, noMarginLeft: avatarNoMarginLeft, src: `${Constants.peoplePictureUrl}${avatarInfo.personId}` }))) : (React.createElement(React.Fragment, null,
            React.createElement(Tooltip, { title: avatarInfo.fullName, "aria-label": avatarInfo.fullName },
                React.createElement(Avatar, { id: id, noMarginLeft: avatarNoMarginLeft, backgroundNumber: avatarInfo.colorFirstLetter }, avatarInfo.firstLetter || ((_a = avatarInfo.fullName) === null || _a === void 0 ? void 0 : _a.substr(0, 1)) || '')),
            Boolean(avatarLabel) && (React.createElement(Text, { className: autoHideSecondaryTextUp ?
                    classes.hideMdUp : (autoHideSecondaryTextDown ?
                    classes.hideSmDown : undefined), size: "small" }, avatarLabel)))))) : (React.createElement("div", { className: classes.noAvatar })),
        React.createElement("div", { className: classes.name },
            Boolean(avatarInfo.fullName) && (React.createElement(React.Fragment, null, TextLinkProps && TextLinkProps.id ? (React.createElement(Text, Object.assign({ className: classes.primaryText }, omit(primaryTextProps, ['children'])), TextLinkTooltipProps ? (React.createElement(Tooltip, Object.assign({}, omit(TextLinkTooltipProps, ['children'])),
                React.createElement("span", null,
                    React.createElement(TextLink, Object.assign({}, omit(TextLinkProps, ['children'])), avatarInfo.fullName)))) : (React.createElement(TextLink, Object.assign({}, omit(TextLinkProps, ['children'])), avatarInfo.fullName)))) : (React.createElement(Text, Object.assign({ className: classes.primaryText }, omit(primaryTextProps, ['children'])), avatarInfo.fullName)))),
            Boolean(avatarInfo.peopleId) && (React.createElement(Text, Object.assign({ className: autoHideSecondaryTextUp ?
                    classes.hideMdUp : (autoHideSecondaryTextDown ?
                    classes.hideSmDown : undefined) }, omit(secondaryTextProps, ['children'])), avatarInfo.peopleId)),
            Boolean(complement) && (React.createElement("div", null, complement)))));
};
AvatarText.defaultProps = {
    autoHideCheckbox: false,
    autoHideSecondaryTextDown: false,
    autoHideSecondaryTextUp: false,
    showAvatar: true,
    showCheckbox: true,
    withAvatar: true
};
export default withStyles(styles)(AvatarText);
